import { render, staticRenderFns } from "./KeyWordStatistics.vue?vue&type=template&id=729b890f&"
import script from "./KeyWordStatistics.vue?vue&type=script&lang=js&"
export * from "./KeyWordStatistics.vue?vue&type=script&lang=js&"
import style0 from "./KeyWordStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('729b890f')) {
      api.createRecord('729b890f', component.options)
    } else {
      api.reload('729b890f', component.options)
    }
    module.hot.accept("./KeyWordStatistics.vue?vue&type=template&id=729b890f&", function () {
      api.rerender('729b890f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/KeyWordStatistics.vue"
export default component.exports